import React, { useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import ApiConnect from "../../../../Utils/ApiConnect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
export default function Entries() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [reportList, setreportList] = useState([]);
  const fetchReport = () => {
    ApiConnect.get(
      `/Module/Inventory/Stock/StockReport?form=${format(
        startDate,
        "yyyy-MM-dd"
      )}&to=${format(endDate, "yyyy-MM-dd")}`
    )
      .then((response) => {
        setreportList(response.data);
      })
      .catch((error) => console.log(error));
  };
  const columns = [
    {
      key: "date",
      text: "Date",
      sortable: true,
    },
    {
      key: "product",
      text: "Product",
      sortable: true,
      width: 300,
    },
    {
      key: "qty",
      text: "Qty",
      sortable: true,
    },
    {
      key: "damage",
      text: "Damage",
      sortable: true,
    },
    {
      key: "expire",
      text: "Expire",
      sortable: true,
    },
    {
      key: "user",
      text: "User",
      className: "table-actions",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        return (
          <React.Fragment>
            <img
              className="avatar avatar-sm"
              src={record.user.avatar}
              alt={record.user.name}
            />
          </React.Fragment>
        );
      },
    },
  ];
  const config = {
    key_column: "id",
    page_size: 30,
    length_menu: [30, 60, 90],
    show_filter: true,
    show_pagination: true,
    button: {
      // excel: true,
      // print: true
    },
    language: {
      loading_text: "Please be patient while data loads...",
    },
  };
  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        <header className="header no-border">
          <div className="header-info mb-0">
            <div className="left">
              <h2 className="header-title">
                <strong>Stock Entires</strong>
              </h2>
            </div>
            <div className="right row">
              <div className="input-group col">
                <label htmlFor="start">From Date</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={startDate}
                  value={startDate}
                  onChange={(e) => setStartDate(e)}
                  placeholderText="Start Date"
                />
              </div>
              <div className="input-group col">
                <label htmlFor="start">To Date</label>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  closeOnScroll={true}
                  selected={endDate}
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                  placeholderText="End Date"
                />
              </div>
              <button
                className="btn btn-primary col-2 btn-sm"
                onClick={() => fetchReport()}
              >
                Fetch
              </button>
            </div>
          </div>
          <div className="header-action"></div>
        </header>
        <div className="card-body">
          <div className="dataTables_wrapper">
            <ReactDatatable
              className="table table-separated"
              config={config}
              records={reportList}
              columns={columns}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
